import http from "./httpService";
import { apiUrl } from "../lib/config";
const apiEndpoint = apiUrl + "/filters";

export function getDeliveryTypes() {
  return http.get(`${apiEndpoint}/delivery-list`);
}
